import React from "react";

interface WordmarkProps {
  // Font-size for the wordmark; accepts any valid CSS length (e.g. "4rem", "22px").
  size?: string;
  className?: string;
}

/**
 * The RankBet brand logo, rendered purely as a two-tone wordmark (no icon).
 * "Rank" in white, "Bet" in the brand's cyan accent — reused by AppHeader
 * (large) and LandingPage (small) so both stay in sync.
 */
const Wordmark: React.FC<WordmarkProps> = ({ size, className }) => (
  <span
    className={["wordmark", className].filter(Boolean).join(" ")}
    style={size ? { fontSize: size } : undefined}
  >
    <span className="wordmark-rank">Rank</span>
    <span className="wordmark-bet">Bet</span>
  </span>
);

export default Wordmark;
